import { css } from 'styled-components';
import { darken } from 'polished';
import { themeGet } from 'styled-system';

const getState = ({
  state,
  bg,
  color,
  darkenPercent,
  borderColor,
  interactionBg,
  interactionColor,
  variant
}) => {
  if (variant === 'primary') {
    return css(["&:", "{background-color:", ";border-color:", ";color:", ";}"],
    /* sc-prop */
    state, () => darken(darkenPercent, interactionBg || bg), () => borderColor && darken(darkenPercent, borderColor), () => interactionColor || null);
  }

  return css(["&:", "{border-color:", ";color:", ";}"],
  /* sc-prop */
  state, () => borderColor && darken(darkenPercent, borderColor), () => darken(darkenPercent, interactionColor || color));
};

const getColor = ({
  color,
  theme
}) => color && themeGet(`colors.${color}`, color)({
  theme
});

const getStates = ({
  bg,
  color,
  disabled = false,
  borderColor,
  interactionColor,
  interactionBg,
  theme,
  variant
}) => {
  if (disabled) return undefined;
  const themeBG = getColor({
    color: bg,
    theme
  });
  const themeBC = getColor({
    color: borderColor,
    theme
  });
  const themeIBG = getColor({
    color: interactionBg,
    theme
  });
  const themeIC = getColor({
    color: variant === 'primary' ? interactionColor : interactionColor || color,
    theme
  });
  return css(["", " ", " ", ""], () => getState({
    state: 'hover',
    darkenPercent: 0.05,
    bg: themeBG,
    disabled,
    borderColor: themeBC,
    interactionBg: themeIBG,
    interactionColor: themeIC,
    variant
  }), () => getState({
    state: 'focus',
    darkenPercent: 0.05,
    bg: themeBG,
    disabled,
    borderColor: themeBC,
    interactionBg: themeIBG,
    interactionColor: themeIC,
    variant
  }), () => getState({
    state: 'active',
    darkenPercent: 0.1,
    bg: themeBG,
    disabled,
    borderColor: themeBC,
    interactionBg: themeIBG,
    interactionColor: themeIC,
    variant
  }));
};

export default getStates;